export const OrgTypes = {
  CORP: 0,
  REGION: 1,
  PRINCIPAL: 2,
  ASSOCIATE: 3,
  CHAIN: 4,
  MERCHANT: 5,
};

// corp=0, region=1, principal=2, associate=3, chain=4
const hierarchyCodeLengths = [3, 5, 8, 11, 14];
const hierarchyCodeTierNames = ['corp', 'region', 'principal', 'associate', 'chain', 'merchant'];

// generate a hierarchyCode given the segments and org type
export const generateHierarchyCode = ({ type, corp, region, principal, associate, chain }) => {
  const fullCode = (corp || '') + (region || '') + (principal || '') + (associate || '') + (chain || '');
  const typeIndex = hierarchyCodeTierNames[type.toLowerCase()];
  return fullCode.slice(0, hierarchyCodeLengths[typeIndex]);
};

export const getOrgTypes = () => {
  return [0, 1, 2, 3, 4, 5];
};

// convert org name to org type
export const getOrgType = ({ type }) => {
  return OrgTypes[type.toUpperCase()];
};

export const getOrgName = (orgType) => {
  return hierarchyCodeTierNames[orgType];
};

// given a hierarchyCode, return the hierarchyCode of the ancestor of the requested type
export const getAncestorHierarchyCode = (orgType, descendantHierarchyCode) => {
  return descendantHierarchyCode ? descendantHierarchyCode.slice(0, hierarchyCodeLengths[orgType]) : null;
};

export const getOrgLabelFromHierarchyCode = (orgType, hierarchyCode) => {
  if (orgType === OrgTypes.CORP) return hierarchyCode;
  const start = hierarchyCodeLengths[orgType - 1];
  return hierarchyCode.slice(start);
};

export const getLowestHierarchyLevel = (organizationContent) => {
  if (organizationContent === undefined || organizationContent.length === 0) {
    return '';
  }
  const organizationTypes = organizationContent.map((element) => { return OrgTypes[element.type.toUpperCase()]; })
                                               .filter(checkIfUnique)
                                               .sort((a, b) => b - a);
  return hierarchyCodeTierNames[organizationTypes[0]].toUpperCase();
};

function checkIfUnique(value, index, self) {
  return self.indexOf(value) === index;
}
